import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import styled from 'styled-components'; // import Icon from '../MyIcon'
import clazz from 'classnames';
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var StyledNestToast = styled.div.withConfig({
    displayName: "NestToast__StyledNestToast",
    componentId: "sc-1d2ohg8-0"
})([
    "background-color:#edefff;font-size:15px;border-radius:6px;padding:14px 16px;&.alpha{border-color:rgba(79,96,255,0.1);background-color:rgba(79,96,255,0.1);}svg{margin-right:8px;flex:none;}span{line-height:22px;color:#4f60ff;}&.error{background-color:#f8eeed;&.alpha{border-color:rgba(187,83,79,0.1);background-color:rgba(187,83,79,0.1);}",
    " span{",
    "}}"
], {
    "color": "var(--color-text-danger)"
}, {
    "color": "var(--color-text-danger)"
});
var NestToast = function(props) {
    var className = props.className, _showIcon = props.showIcon, showIcon = _showIcon === void 0 ? true : _showIcon, text = props.text, _alpha = props.alpha, alpha = _alpha === void 0 ? false : _alpha, type = props.type, rest = _objectWithoutProperties(props, [
        "className",
        "showIcon",
        "text",
        "alpha",
        "type"
    ]); // let iconType = 'kaas-warn-outline'
    return(/*#__PURE__*/ _jsx(StyledNestToast, _objectSpread({
        className: clazz([
            className,
            {
                error: type === 'error',
                alpha: alpha
            }
        ])
    }, rest, {
        children: /*#__PURE__*/ _jsx("span", {
            dangerouslySetInnerHTML: {
                __html: text
            }
        })
    })));
};
export default NestToast;
